var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVerticleEllipsisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 22,
    viewBox: "0 0 4 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.875C2.62132 3.875 3.125 3.37132 3.125 2.75C3.125 2.12868 2.62132 1.625 2 1.625C1.37868 1.625 0.875 2.12868 0.875 2.75C0.875 3.37132 1.37868 3.875 2 3.875Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.125C2.62132 12.125 3.125 11.6213 3.125 11C3.125 10.3787 2.62132 9.875 2 9.875C1.37868 9.875 0.875 10.3787 0.875 11C0.875 11.6213 1.37868 12.125 2 12.125Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.375C2.62132 20.375 3.125 19.8713 3.125 19.25C3.125 18.6287 2.62132 18.125 2 18.125C1.37868 18.125 0.875 18.6287 0.875 19.25C0.875 19.8713 1.37868 20.375 2 20.375Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticleEllipsisIcon);
export default __webpack_public_path__ + "static/media/verticleEllipsisIcon.06f1ae23720b03bf7fb012e47da3e391.svg";
export { ForwardRef as ReactComponent };